import React from 'react';
import { makeStyles } from '@material-ui/core';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import FlagstoneTheme from '../../Config/flagstoneTheme';

export default function UserTableRow(props) {

    const classes = useStyles();
    // const [showSteps, setShowsSteps] = useState(false)


    const openSteps = (userId) => {
        props.editUser(userId);
    }

    const CustomCell = (prop) => {
        return (
            <TableCell className={classes.infoCell} style={{ backgroundColor: props.active ? "#fef6ef" : "#f4fff5" }} onClick={() => openSteps(prop.id)}>{prop.value}</TableCell>
        );
    }

    const FirstCell = (prop) => {
        return (
            <TableCell className={classes.firstCell} style={{ backgroundColor: props.active ? "#fef6ef" : "#f4fff5" }} onClick={() => openSteps(prop.id)}>{prop.value}</TableCell>
        );
    }

    const LastCell = (prop) => {
        return (
            <TableCell className={classes.lastCell} style={{ backgroundColor: props.active ? "#fef6ef" : "#f4fff5" }} onClick={() => openSteps(prop.id)}>{prop.value}</TableCell>
        );
    }

    const RollCell = (prop) => {
        return (
            <TableCell className={classes.infoCell} style={{ backgroundColor: props.active ? "#fef6ef" : "#f4fff5" }} onClick={() => openSteps(prop.id)}>
                {
                    prop.value.map((x,i, arr) => {
                        return (<React.Fragment key={x.roleId}><span key={x.roleId} style={{ color: x.color, fontWeight: "bold" }}>{x.name}</span>
                            {i < arr.length - 1 && <span>{",  "}</span>}
                        </React.Fragment>)
                    })
                }
            </TableCell>
        );
    }

    return (
        <React.Fragment key={props.row.id}>
            <TableRow key={props.row.id} className={classes.row}>
                <FirstCell value={props.row.id} id={props.row.id}></FirstCell>
                <CustomCell value={props.row.loginName} id={props.row.id}></CustomCell>
                <CustomCell value={props.row.firstName} id={props.row.id}></CustomCell>
                <CustomCell value={props.row.lastName} id={props.row.id}></CustomCell>
                <CustomCell value={props.row.email} id={props.row.id}></CustomCell>
                <RollCell value={props.row.rollen} id={props.row.id}></RollCell>
                <LastCell value={""} id={props.row.id}></LastCell>
            </TableRow>
        </React.Fragment>
    )
}

const useStyles = makeStyles({
    infoCell: {
        padding: "15px !important",
        border: "none",
        fontSize: "14",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#020100",
        cursor: "pointer",
        borderTop: "1px solid #cfcfd0 !important",
        borderBottom: "1px solid #cfcfd0 !important",
    },
    arrowCell: {
        padding: "3px !important",
        border: "none",
        fontSize: "20px",
        fontFamily: "monospace",
        fontWeight: "300",
        color: "#cfcfd0",
        cursor: "pointer",
        borderTop: "1px solid #cfcfd0 !important",
        borderBottom: "1px solid #cfcfd0 !important",
    },
    firstCell: {
        padding: "3px !important",
        border: "none",
        paddingLeft: "15px !important",
        fontSize: "14",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#020100",
        cursor: "pointer",
        borderTop: "1px solid #cfcfd0 !important",
        borderBottom: "1px solid #cfcfd0 !important",
        borderLeft: "1px solid #cfcfd0 !important",
        borderRadius: "5px 0 0 5px"
    },
    lastCell: {
        padding: "3px !important",
        border: "none",
        fontSize: "14",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#020100",
        cursor: "pointer",
        borderTop: "1px solid #cfcfd0 !important",
        borderBottom: "1px solid #cfcfd0 !important",
        borderRight: "1px solid #cfcfd0 !important",
        borderRadius: "0 5px 5px 0"
    },
    row: {
        '&:nth-of-type(odd)': {
            backgroundColor: "#F4F4F4",
        },

    },
    rowButton: {
        outline: "none",
        border: "none",
        cursor: "pointer",
        backgroundColor: "rgb(1,1,1,0)",
        width: "100%",
        height: "100%"
    },
    expand: {
        color: FlagstoneTheme.palette.primary.main
    }

});



